import { Component, OnDestroy, OnInit } from '@angular/core';

import { Actions, ofActionSuccessful } from '@ngxs/store';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';


import { ChangePlayerInputModel } from '../../models/change-player-input.model';
import { ChangePlayerSuccessAction } from './../../+store/players.actions';
import { PlayersFacade } from './../../+store/players.facade';

@Component({
    selector: 'app-change-player-modal',
    templateUrl: './change-player-modal.component.html',
    styleUrls: ['./change-player-modal.component.scss'],
    standalone: false
})
export class ChangePlayerModalComponent implements OnInit, OnDestroy {
    changePlayerInput: ChangePlayerInputModel;

    player$ = this.playerFacade.player$;
    players$ = this.playerFacade.players$;
    selectedPlayer$ = this.playerFacade.selectedPlayer$;
    selectedPlayerRulesMatrix$ = this.playerFacade.selectedPlayerRulesMatrix$;

    selectedTab: PlayerChangeTab = PlayerChangeTab.searchPlayerTab;

    subscription: Subscription = new Subscription();
    constructor(public bsModalRef: BsModalRef, private playerFacade: PlayersFacade, private actions$: Actions) { }

    ngOnInit(): void {
        this.playerFacade.loadPlayer(this.changePlayerInput);
        this.subscription.add(
            this.actions$.pipe(ofActionSuccessful(ChangePlayerSuccessAction)).subscribe(value => {
                this.bsModalRef.hide();
            })
        );
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        this.playerFacade.clearPlayersFormData();
    }

    update() {
        this.playerFacade.changePlayer(this.changePlayerInput.courtBookingId);
    }

    setSearchTabActive() {
        this.playerFacade.clearPlayers();
        this.selectedTab = PlayerChangeTab.searchPlayerTab;
    }

    setAddPlayerTabActive() {
        this.playerFacade.clearPlayers();
        this.selectedTab = PlayerChangeTab.addNewPlayerTab;
    }

    get isSearchTabActive(): boolean {
        return this.selectedTab === PlayerChangeTab.searchPlayerTab;
    }

    get isAddNewPlayerTabActive(): boolean {
        return this.selectedTab === PlayerChangeTab.addNewPlayerTab;
    }
}

export enum PlayerChangeTab {
    searchPlayerTab,
    addNewPlayerTab
}
